import { Route } from 'react-router';
import PortalBase from './PortalBase';
import Authorized, { AUTH_LEVELS } from '../../auth/Authorized';
import LoginContainer from '../../login/LoginContainer';
import PasswordReset from '../../login/PasswordReset';
import SandboxRequest from '../../auth/SandboxRequest';
import Dashboard from '../../dashboard/Dashboard';
import NewBuilding from '../../configuration/NewBuilding';
import DeploymentsPage from '../../deployments/DeploymentsPage';
import DataAlerts from '../../monitoring/DataAlerts';
import Exports from '../../exports/Exports';
import ExportEditor from '../../exports/ExportEditor';

const { PORTAL_USER, ORG_ADMIN } = AUTH_LEVELS;

const Auth = Authorized(LoginContainer);
const App = () => (
  <PortalBase auth={Auth} loginType={LoginContainer}>
    <Route path="/password-reset" element={<PasswordReset />} />
    <Route path="/password-reset/:email/:token" element={<PasswordReset />} />
    <Route path="/sandbox-request" element={<SandboxRequest />} />
    <Route
      path="/buildings/new"
      element={<Auth child={NewBuilding} level={ORG_ADMIN} componentProps={{ existing: false }} />}
    />
    <Route path="/data-alerts" element={<Auth child={DataAlerts} level={PORTAL_USER} />} />
    <Route path="/deployments" element={<Auth child={DeploymentsPage} level={PORTAL_USER} />} />
    <Route path="/exports" element={<Auth child={Exports} level={PORTAL_USER} />} />
    <Route path="/exports/new" element={<Auth child={ExportEditor} level={PORTAL_USER} />} />
    <Route
      path="/exports/edit/:exportId"
      element={<Auth child={ExportEditor} level={PORTAL_USER} />}
    />
    <Route path="/dashboard" element={<Auth child={Dashboard} level={PORTAL_USER} />} />
  </PortalBase>
);
export default App;
